import { TabSwitch, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { customerConsortiumSectionStatusState } from '../../../../store/consortium/atom';
import { customerConsortiumPlanIsSelectedSelector } from '../../../../store/consortium/selector';

import { MyConsortiums } from './components/MyConsortiums';
import { Simulate } from './components/Simulate';
import { CategorySelected } from './components/Simulate/components/CategorySelected';

const Container = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  if (isMobile) {
    return <VStack pt={Spacing['inline.xxxs']}>{children}</VStack>;
  }

  return (
    <Box
      p={Spacing['inline.xxs']}
      bg="neutral.white"
      w="full"
      alignItems="center"
      mt={Spacing['inline.xxs']}
      borderRadius={BoxRadius.sm}>
      {children}
    </Box>
  );
};

export const Tabs: React.FC = () => {
  const customerSectionStatus = useRecoilValue(customerConsortiumSectionStatusState);
  const customerConsortiumPlanIsSelected = useRecoilValue(customerConsortiumPlanIsSelectedSelector);
  const isCustomerSectionClosed = customerSectionStatus === 'closed';

  const consortiumTabs = [
    {
      key: 'my-consortiums',
      label: 'Meus consórcios',
      component: (
        <Container>
          <MyConsortiums />
        </Container>
      ),
    },
    {
      key: 'simulate',
      label: 'Simular consórcio',
      component: (
        <Container>
          <Simulate />
        </Container>
      ),
    },
  ];

  const consortiumInitialTab = consortiumTabs[0].key;

  const [selectedTab, setSelectedTab] = useState(consortiumInitialTab);

  const isMobile = useBreakpointValue({
    base: true,
    sm: false,
  });

  if (!isCustomerSectionClosed) {
    return null;
  }

  if (customerConsortiumPlanIsSelected) {
    return <CategorySelected />;
  }

  return (
    <VStack flex={1}>
      <TabSwitch
        testId="tab-switch-consortium"
        tabs={consortiumTabs}
        selectedTab={selectedTab}
        onTabPress={setSelectedTab}
        isMobile={isMobile}
        isLoading={false}
      />
    </VStack>
  );
};
